import { render, staticRenderFns } from "./VirtualCourt.vue?vue&type=template&id=08d797f7&scoped=true"
import script from "./VirtualCourt.vue?vue&type=script&lang=js"
export * from "./VirtualCourt.vue?vue&type=script&lang=js"
import style0 from "./VirtualCourt.vue?vue&type=style&index=0&id=08d797f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d797f7",
  null
  
)

export default component.exports